import styled, { createGlobalStyle } from 'styled-components';

export const CampaignsWrapper = styled.div`
	padding: 16px;
`;

export const GlobalCampaignStyle = createGlobalStyle`
	.MuiFormControl-root.MuiTextField-root {
		margin-top: 0 !important;
	}
	.MuiSwitch-switchBase {
		top: -7px !important;
	}

`;
